import { render, staticRenderFns } from "./spcodaccard_audit.vue?vue&type=template&id=3023b705&scoped=true"
import script from "./spcodaccard_audit.vue?vue&type=script&lang=js"
export * from "./spcodaccard_audit.vue?vue&type=script&lang=js"
import style0 from "./spcodaccard_audit.vue?vue&type=style&index=0&id=3023b705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3023b705",
  null
  
)

export default component.exports